import { NON_CONFORMITY_PRODUCTION_ROWS, NON_CONFORMITY_TECHNICAL_ROWS } from "../controleConstants";
import { CHARTER_THEME } from "../controleTheme";
import { nonConformityBodyCellStyle, nonConformityHeaderCellStyle } from "../styles/reportStyles";

export function NonConformityReport({ meta, onMetaChange, dateProduction, value, onChange }) {
    const { inputStyle } = CHARTER_THEME;
    const data = value || {};

    const updateRow = (group, key, patch) => {
        onChange({
            ...data,
            [group]: {
                ...(data[group] || {}),
                [key]: {
                    ...((data[group] || {})[key] || {}),
                    ...patch,
                },
            },
        });
    };

    const updateField = (key, nextValue) => {
        onChange({ ...data, [key]: nextValue });
    };

    return (
        <div style={{
            display: "grid",
            gap: "18px",
            padding: "18px",
            background: "white",
            border: "1px solid #cbd5e1",
            borderRadius: "8px",
            boxShadow: "0 1px 3px rgba(15, 23, 42, 0.06)",
        }}>
            <div style={{ textAlign: "center", color: "#0f172a", fontSize: "20px", fontWeight: 950, textTransform: "uppercase" }}>
                Fiche de signalement de non conformité de production - Pharmacie
            </div>

            <div style={{
                display: "grid",
                gridTemplateColumns: "minmax(260px, 1fr) minmax(260px, 1fr)",
                gap: "14px",
                color: "#0f172a",
                fontSize: "14px",
                lineHeight: 1.5,
            }}>
                <div style={{ display: "grid", gap: "4px" }}>
                    <NonConformityInfo
                        label="Nombre de sachets produits"
                        value={meta.nombreSachetsProduits || ""}
                        onChange={value => onMetaChange("nombreSachetsProduits", value)}
                    />
                    <NonConformityInfo
                        label="Nombre de patients"
                        value={meta.nombrePatients || ""}
                        onChange={value => onMetaChange("nombrePatients", value)}
                    />
                    <NonConformityInfo
                        label="Temps de production"
                        value={meta.tempsProduction || ""}
                        onChange={value => onMetaChange("tempsProduction", value)}
                    />
                </div>
                <div style={{ display: "grid", gap: "4px", alignContent: "start" }}>
                    <NonConformityInfo
                        label="Lancement de production le"
                        value={data.dateProduction || dateProduction || ""}
                        type="date"
                        onChange={value => updateField("dateProduction", value)}
                    />
                    <NonConformityInfo
                        label="à"
                        value={meta.lancementHeure || ""}
                        type="time"
                        onChange={value => onMetaChange("lancementHeure", value)}
                    />
                </div>
            </div>

            <NonConformityTable
                title="Non-conformité liée à la production"
                countTitle="Nbre sachet"
                rows={NON_CONFORMITY_PRODUCTION_ROWS}
                values={data.production || {}}
                onChange={(key, patch) => updateRow("production", key, patch)}
            />

            <NonConformityTable
                title="Défaut technique de production"
                countTitle="Nbre patient"
                rows={NON_CONFORMITY_TECHNICAL_ROWS}
                values={data.technique || {}}
                onChange={(key, patch) => updateRow("technique", key, patch)}
            />

            <div style={{
                display: "grid",
                gap: "14px",
                padding: "14px",
                border: "1px solid #cbd5e1",
                borderRadius: "8px",
                background: "#f8fafc",
            }}>
                <label style={{ display: "grid", gap: "7px" }}>
                    <span style={{ color: "#0f172a", fontSize: "14px", fontWeight: 900 }}>Commentaire/autre problème:</span>
                    <textarea
                        style={{ ...inputStyle, width: "100%", minHeight: "86px", resize: "vertical", lineHeight: 1.45 }}
                        value={data.commentaireAutre || ""}
                        onChange={event => updateField("commentaireAutre", event.target.value)}
                        placeholder="Commentaire"
                    />
                </label>
                <div style={{ display: "grid", gridTemplateColumns: "minmax(220px, 1fr) minmax(220px, 1fr)", gap: "12px" }}>
                    <label style={{ display: "grid", gap: "6px" }}>
                        <span style={{ color: "#334155", fontSize: "13px", fontWeight: 800 }}>Nom</span>
                        <input
                            style={{ ...inputStyle, width: "100%" }}
                            value={data.nom || ""}
                            onChange={event => updateField("nom", event.target.value)}
                            placeholder="Nom"
                        />
                    </label>
                    <label style={{ display: "grid", gap: "6px" }}>
                        <span style={{ color: "#334155", fontSize: "13px", fontWeight: 800 }}>Signature Pharmacien</span>
                        <input
                            style={{ ...inputStyle, width: "100%" }}
                            value={data.signaturePharmacien || ""}
                            onChange={event => updateField("signaturePharmacien", event.target.value)}
                            placeholder="Signature"
                        />
                    </label>
                </div>
            </div>
        </div>
    );
}

export function NonConformityInfo({ label, value, type = "text", onChange }) {
    const { inputStyle } = CHARTER_THEME;
    return (
        <label style={{ display: "grid", gridTemplateColumns: "minmax(190px, auto) minmax(120px, 1fr)", gap: "8px", alignItems: "center" }}>
            <span style={{ fontWeight: 800 }}>{label} :</span>
            <input
                type={type}
                style={{ ...inputStyle, width: "100%" }}
                value={value}
                onChange={event => onChange(event.target.value)}
            />
        </label>
    );
}

export function NonConformityTable({ title, countTitle, rows, values, onChange }) {
    const { inputStyle } = CHARTER_THEME;
    return (
        <div style={{ overflowX: "auto", border: "1px solid #cbd5e1", borderRadius: "8px", background: "white" }}>
            <table style={{ width: "100%", minWidth: "760px", borderCollapse: "collapse" }}>
                <thead>
                    <tr style={{ background: "#f1f5f9" }}>
                        <th style={nonConformityHeaderCellStyle}>{title}</th>
                        <th style={{ ...nonConformityHeaderCellStyle, width: "130px", textAlign: "center" }}>{countTitle}</th>
                        <th style={nonConformityHeaderCellStyle}>Corrections apportées</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map(([key, label]) => {
                        const row = values[key] || {};
                        return (
                            <tr key={key}>
                                <td style={nonConformityBodyCellStyle}>{label}</td>
                                <td style={{ ...nonConformityBodyCellStyle, width: "130px" }}>
                                    <input
                                        style={{ ...inputStyle, width: "100%", textAlign: "center" }}
                                        value={row.nombre ?? "N"}
                                        onChange={event => onChange(key, { nombre: event.target.value })}
                                    />
                                </td>
                                <td style={nonConformityBodyCellStyle}>
                                    <textarea
                                        style={{ ...inputStyle, width: "100%", minHeight: "44px", resize: "vertical", lineHeight: 1.35 }}
                                        value={row.correction || ""}
                                        onChange={event => onChange(key, { correction: event.target.value })}
                                        placeholder="Correction apportée"
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
